(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bandz-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bandz-journal')) {
    customElements.define('bandz-journal', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const nav = this.querySelector('[data-journal-filters]');
        if (!nav) return;
        nav.hidden = false;
        nav.addEventListener('click', event => {
          const button = event.target.closest('[data-journal-filter]');
          if (!button || !nav.contains(button)) return;
          const category = button.dataset.journalFilter;
          let count = 0;
          this.querySelectorAll('[data-story]').forEach(card => {
            const visible = category === 'all' || card.dataset.categories.split(' ').includes(category);
            card.hidden = !visible;
            if (visible) count += 1;
          });
          nav.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          const status = this.querySelector('[data-filter-status]');
          if (status) status.textContent = count === 1 ? status.dataset.oneText : status.dataset.countText.replace('__COUNT__', count);
          const feature = this.querySelector('.bj-feature');
          if (feature) feature.hidden = !feature.querySelector('[data-story]:not([hidden])');
          const stories = this.querySelector('.bj-story-section');
          if (stories) stories.hidden = !stories.querySelector('[data-story]:not([hidden])');
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forever-bandz-prelaunch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('society-page')) {
    customElements.define('society-page', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
        const options = { signal: this.controller.signal };
        this.motionQuery.addEventListener('change', () => this.updateMotion(), options);
        this.pointerQuery.addEventListener('change', () => this.updateMotion(), options);
        this.updateMotion();
      }
      updateMotion() {
        this.observer?.disconnect();
        this.interactions?.abort();
        this.interactions = new AbortController();
        this.querySelectorAll('.is-in-view').forEach(element => element.classList.remove('is-in-view'));
        if (this.dataset.motion !== 'true' || this.motionQuery.matches) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in-view');
                this.observer.unobserve(entry.target);
              }
            });
          }, { threshold: .08 });
          this.querySelectorAll('.society-reveal').forEach(element => this.observer.observe(element));
        }
        if (!this.pointerQuery.matches) return;
        const signal = this.interactions.signal;
        this.querySelectorAll('[data-hanger]').forEach(media => {
          const stage = media.querySelector('.society-product__stage');
          if (!stage) return;
          let bounds;
          let frame;
          let point;
          const reset = () => {
            cancelAnimationFrame(frame);
            frame = null;
            bounds = null;
            stage.style.removeProperty('--hanger-x');
            stage.style.removeProperty('--hanger-y');
          };
          media.addEventListener('pointerenter', () => { bounds = media.getBoundingClientRect(); }, { signal });
          media.addEventListener('pointermove', event => {
            if (!bounds || !bounds.width || !bounds.height) return;
            point = { x: event.clientX, y: event.clientY };
            if (frame) return;
            frame = requestAnimationFrame(() => {
              const x = Math.max(-.5, Math.min(.5, (point.x - bounds.left) / bounds.width - .5));
              const y = Math.max(-.5, Math.min(.5, (point.y - bounds.top) / bounds.height - .5));
              stage.style.setProperty('--hanger-x', `${-y * 3}deg`);
              stage.style.setProperty('--hanger-y', `${x * 5}deg`);
              frame = null;
            });
          }, { signal });
          media.addEventListener('pointerleave', reset, { signal });
          media.addEventListener('pointercancel', reset, { signal });
          signal.addEventListener('abort', reset, { once: true });
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.interactions?.abort();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
